import { render, staticRenderFns } from "./ShopDetails.vue?vue&type=template&id=23da81e6&scoped=true&xmlns%3Av=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./ShopDetails.vue?vue&type=script&lang=js"
export * from "./ShopDetails.vue?vue&type=script&lang=js"
import style1 from "./ShopDetails.vue?vue&type=style&index=1&id=23da81e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23da81e6",
  null
  
)

export default component.exports